// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1y9OQ","type":"styles_type__vT27e","choices":"styles_choices__QySrm"};